import { JSXElementConstructor, ReactElement } from "react";
import { Controller, ControllerFieldState, ControllerRenderProps, FieldValues } from "react-hook-form";
import { FormControl, FormHelperText, InputLabel, Select, SelectChangeEvent } from "@mui/material";

export default function SelectElement({
  name,
  label,
  children,
  onChange = () => {},
  disabled = false,
  helperText = "",
  validation = {},
  ...rest
}: any) {
  return (
    <Controller
      rules={validation}
      render={function ({
        field,
        fieldState,
      }: {
        field: ControllerRenderProps<FieldValues, string>;
        fieldState: ControllerFieldState;
      }): ReactElement<any, string | JSXElementConstructor<any>> {
        return (
          <FormControl fullWidth={true} margin={"normal"} disabled={disabled} error={!!fieldState.error}>
            <InputLabel>{label}</InputLabel>
            <Select
              {...field}
              value={field.value || ""}
              onChange={(event: SelectChangeEvent<unknown>) => {
                field.onChange(event.target.value);
                onChange(event.target.value);
              }}
              label={label}
              {...rest}
            >
              {children}
            </Select>
            {(!!fieldState.error || helperText) && (
              <FormHelperText>{fieldState.error?.message || helperText}</FormHelperText>
            )}
          </FormControl>
        );
      }}
      name={name}
    />
  );
}
